export default {
    'Version': 'Workflow Version',
    'FinishTime': 'Finish Time：{time}',
    'CancelTime': 'Cancel Time：{time}',
    'CurNode': 'Current Activity',
    'CurHandler': 'Current Approvers',
    'UsedTime': 'Used Time {time}',
    'WorkflowTrack': 'Workflow track',
    'Edit': 'Edit',
    'AdjustNode': 'Activities Adjustment',
    'ProcessOperationAndMaintenance': 'Process Operation And Maintenance',
    'Nullify': 'Cancel',
    'Delete': 'Delete',
    'Logs': 'Operate Log',
    'Finish': 'Finish',
    'EditOwner': 'Modify owner',
    'NullifyTips': 'The workflow will be stuck after cancel,are you sure to cancel？',
    'NullifyTips1': 'Sure to void？',
    'NullifyTips2': 'The process will stop circulating after it is invalidated',
    'DeleteTips1': 'All workflow data will be delete after workflow instance be deleted，',
    'DeleteTips2': 'and it can not restore after delete，',
    'DeleteTips3': 'Are you sure to delete？',
    'FinishWorkflow': 'End the Workflow ahead of schedule',
    'FinishWorkflowTips': 'Are you sure to end the workflow right now？',
    'WorkflowChart': 'WorkFlow diagram',
    'SmallScreen': 'Small screen',
    'ApprovalLog': 'Approve Log',
    'Back': 'Back',
    'OperationLogs': 'User Operation Log',
    'View': 'Check',
    'DetailInfo': 'Details',
    'Number': 'NO.',
    'OperationType': 'Operation Type',
    'OperationTime': 'Operation Time',
    'User': 'User',
    'Operations': 'Operation with',
    'Platform': 'Platform',
    'Detail': 'Details',
    'Assist': ' assist]',
    'AddWorkitem': ' add-approver]',
    'Circulate': ' circulate]',
    'Forward': ' transfer]',
    'ActivityName': 'Activity Name',
    'ReceiveTime': 'Received Time',
    'FinishTimes': 'Finish Time',
    'CostTime': 'Used Time',
    'Originator': 'Paticipants',
    'ApprovalAction': 'Action',
    'FinishNode': 'Ended Activity',
    'ProcessNode': 'Processing Activity',
    'ExceptionNode': 'Abnormal Activity',
    'UnstartNode': 'Unstarted Activity',
    'WorkflowName': 'Workflow Name',
    'Status': 'Status',
    'StartTime': 'Start Time',
    'FinishedTime': 'End Time',
    'BaseInfo': 'Basic Information',
    'NoFinishOriginator': 'Unfinished Approver',
    'ViewDetails': 'Details',
    'ChooseAdjustType': 'Choose a type',
    'AdjustOriginator': 'Current Approver Adjustment',
    'CancelAllTask': 'Cancel all task of the activity',
    'ActivateNodes': 'Activate another activity',
    'AdjustNodeTips': 'Tips:Workflow will keep stuck,and administrator need to activate another activity.',
    'notNodeTips': 'No nodes currently available',
    'ChooseNode': 'Choose Activity',
    'ChooseHandler': 'Choose the approver',
    'ClickChoose': 'Click and choose',
    'Null': 'Empty',
    'Nothing': 'Nothing',
    'Cancel': 'Cancel',
    'OK': 'OK',
    'Predictor': 'Predict approver',
    'NoDetail': 'There is no details',
    'trust': '【{name} entrust】',
    'trust2': ' entrust',
    'WorkflowState': {
        'Draft': 'Draft',
        'Processing': 'Processing',
        'Completed': 'Completed',
        'Canceled': 'Canceled',
        'Exception': 'Exception',
    },
    'WorkflowActionStatus': {
        'Submit': 'Submit',
        'Submits': 'Submit',
        'Cancel': 'Cancel',
        'Agree': 'Agree',
        'DisAgree': 'Disagree',
        'AdjustParticipant': 'Add-approver',
        'Assist': 'Assist',
        'Forward': 'Transfer',
        'Reject': 'Reject',
        'FinishInstance': 'End-workflow',
        'UnRead': 'Unread',
        'Read': 'Read',
        'Circularize': 'Circularize',
        'Empty': '',
        'Revoke': 'Revoke',
        'BeCanceled': 'Be Canceled',
        'AutoCanceled': 'Auto Cancel',
        'ActivateActivity': 'Activate Other Nodes',
        'ADJUST_PARTICIPANT': 'Adjust Current Processor',
        'CANCELED_ACTIVITY_WORKITEM': 'Cancel All Tasks Of The Node',
        'MODIFY_OWNER': 'Modify Owner',
    },
    'WorkItemStatus': {
        'NotStarted': 'Not Started',
        'Processing': 'Processing',
        'Completed': 'Completed',
        'Canceled': 'Canceled',
        'Draft': 'Draft',
        'BeCanceled': 'Be Canceled',
    },
    'SubWorkItemStatus': {
        'NotStarted': 'Not Started',
        'Processing': 'Processing',
        'Completed': 'Completed',
        'Canceled': 'Canceled',
        'Exception': 'Exception',
        'BeCanceled': 'Be Canceled',
    },
};
